import { FC, Fragment, ReactNode } from "react";
import styles from "./Header.module.css";

type HeaderProps = {
  title: string;
  buttons?: ReactNode | ReactNode[];
};

const Header: FC<HeaderProps> = ({ title, buttons }: HeaderProps) => (
  <div className={styles.header}>
    <div className={styles.title}>{title}</div>

    {buttons &&
      (Array.isArray(buttons) ? buttons : [buttons])?.map((b, index) => (
        <Fragment key={`button_${index}`}>{b}</Fragment>
      ))}
  </div>
);

export default Header;
